import { Show, splitProps } from "solid-js";
import ListLoader from "./ListLoader";
import { cn } from "@/libs/cn";

import {
  Table,
  TableBody,
} from "@/components/shadcn/table";

const InnerListView = (props) => {
  return (
    <Table>
      <TableBody>
        {props.children}
      </TableBody>
    </Table>
  );
}

const InnerGridView = (props) => {
  return (
    <div class={cn("grid gap-3 py-3", "grid-cols-4", props.grid)}>
      {props.children}
    </div>
  );
}

const InnerFlexView = (props) => {
  return (
    <div class={cn("flex gap-3 py-3", props.flex)}>
      {props.children}
    </div>
  );
}

const InnerView = (props) => {
  if (props.view === "grid") {
    return <InnerGridView grid={props.grid}>{props.children}</InnerGridView>
  } else if (props.view === "flex") {
    return <InnerFlexView>{props.children}</InnerFlexView>
  } else {
    return <InnerListView>{props.children}</InnerListView>
  }
}

export const ListView = (props) => {

  const [local, rest] = splitProps(props, ["class", "loading", "data", "placeholder", "view", "grid", "flex", "template", "checkedItems", "onRowCheck", "onRowAction"]);

  return (
    <div class="w-full border-y-2 py-0">
      <Show when={props.loading && props.placeholder}>
        {props.placeholder}
      </Show>

      <Show when={(props.loading && !props.placeholder)}>
        <div class="py-5 flex justify-center items-center bg-slate-100 dark:bg-zinc-900 height-[250px]">
          <ListLoader />
        </div>
      </Show>

      <Show when={!props.loading && props.data?.length !== 0}>
        <InnerView view={props.view ?? 'list'} grid={props.grid} flex={props.flex}>
          <For each={props.data}>{(item, i) =>
            <Dynamic component={props.template} item={item} items={props.checkedItems} onCheck={props.onRowCheck} onAction={props.onRowAction} {...rest} />
          }</For>
        </InnerView>
      </Show>

      <Show when={!props.loading && props.data?.length === 0}>
        <div class="h-24 flex items-center content-center w-full">
          <p class="text-danger text-medium">No record found!</p>
        </div>
      </Show>
    </div>
  );
}
